import {Group, Text} from "@mantine/core";
import {Link} from "react-router";
import AppInfo from '../../../version.json';

export default function Footer () {
    return (
        <>
            <div className="footer" style={{color: 'var(--mantine-color-dark-2)'}}>
                <Group justify="space-between">
                    <Text size="xs"> The Forge is a tool platform for <Link to="https://www.swcombine.com/" target="_blank" rel="noreferrer">Star Wars Combine</Link> - <Link to="/credits">Credits</Link></Text>
                    <Text size="xs">Version: {AppInfo.version}</Text>
                </Group>
            </div>
        </>
    )
}
